/**
 * Copyright Mántum All Rights Reserved.
 */
import getTheme from './theme';
import { useCallback } from 'react';

import type { Theme } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        entity?: string;
        refresh?: number;
        revalidate?: boolean;
    };
    icon?: string;
    loading?: boolean;
    theme?: Theme;
    title?: string;
    value?: number | string;
};

export default function Simple(props: PropTypes) {
    // prettier-ignore
    const {
        loading = false
    } = props

    const theme = getTheme(props.theme);
    const getLoading = useCallback(() => {
        return loading ? 'animate-pulse' : '';
    }, [loading]);

    return (
        <div className='w-full p-4 flex gap-4 border rounded group cursor-pointer'>
            <div
                className={`rounded w-16 h-16 p-2 group-hover:from-pink-500 group-hover:to-yellow-500 ${theme} ${getLoading()}`}
            >
                {props.icon && (
                    <img
                        className='w-full h-full'
                        src={props.icon}
                        alt='icon'
                    />
                )}
            </div>
            <div className='text-gray-800'>
                <h2
                    className='text-base text-gray-400 truncate'
                    title={props.title}
                >
                    {props.title}
                </h2>
                <p className='text-2xl font-bold min-h-[32px]'>{props.value}</p>
            </div>
        </div>
    );
}
